export const STATE_NAME = "signer";
export const FORM_NAME = STATE_NAME;
export const SUBMISSION_FORM_NAME = "signerSubmission";
